import { render, staticRenderFns } from "./electric-factors.vue?vue&type=template&id=b510a394&scoped=true"
import script from "./electric-factors.vue?vue&type=script&lang=js"
export * from "./electric-factors.vue?vue&type=script&lang=js"
import style0 from "./electric-factors.vue?vue&type=style&index=0&id=b510a394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b510a394",
  null
  
)

export default component.exports